import * as yup from "yup"
import type { Collection } from "../../types"

export function initialValuesCollection(collection?: Collection | undefined) {
  if (collection) {
    return collection
  }
  return {
    name: "",
    description: "",
    category: ""
  }
}

export function validationSchemaCollection() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
    category: yup.string().required("Campo obbligatorio"),
  })
}
